import { GYM_MEMBER_LIMIT_MAX } from '@steado/admin-contract/gyms';

/**
 * What is wrong with a typed member limit, or null. The API refuses the same
 * things (the contract's range, and MEMBER_LIMIT_BELOW_COUNT); saying so here
 * keeps the operator from finding out on Save.
 */
export function memberLimitIssue(text: string, memberCount: number): string | null {
  const trimmed = text.trim();
  if (!/^\d+$/.test(trimmed)) return 'Type a whole number.';
  const limit = Number(trimmed);
  if (limit < 1) return 'Must be at least 1.';
  if (limit > GYM_MEMBER_LIMIT_MAX) return `Must be at most ${GYM_MEMBER_LIMIT_MAX.toLocaleString('en-IN')}.`;
  if (limit < memberCount) {
    return `The gym has ${String(memberCount)} members. End someone’s coaching first, or set at least ${String(memberCount)}.`;
  }
  return null;
}
